export default __webpack_public_path__ + "static/media/arrow-black.6464597f.svg";